import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("至")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("导出excel")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  style: {"color":"red"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tips = _resolveComponent("Tips")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_Tips, { msg: "您可以选择查看指定渠道，指定业务，指定时间段的安装情况。" }),
      _createVNode(_component_el_form, {
        ref: "checkDataFormRef",
        inline: true,
        model: _ctx.checkDataForm,
        class: "demo-form-inline",
        rules: _ctx.checkDataFormRules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "业务名称:",
            prop: "soft_type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.checkDataForm.soft_type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkDataForm.soft_type) = $event)),
                placeholder: "请选择",
                onChange: _ctx.getChannelAccid
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelSoftInfos, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.softid,
                      label: item.softname,
                      value: item.softid
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "渠道号:",
            prop: "accid"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.checkDataForm.accid,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkDataForm.accid) = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    key: "-1",
                    label: "所有渠道",
                    value: "-1"
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelAccid, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.accid,
                      label: item.tag,
                      value: item.accid
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "日期:",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 11 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.checkDataForm.start,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkDataForm.start) = $event)),
                        type: "date",
                        placeholder: "开始日期",
                        style: {"width":"100%"},
                        "value-format": "YYYY-MM-DD",
                        "disabled-date": _ctx.disabledDate
                      }, null, 8, ["modelValue", "disabled-date"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                class: "line",
                span: 4,
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 11 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.checkDataForm.end,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkDataForm.end) = $event)),
                        type: "date",
                        placeholder: "结束日期",
                        style: {"width":"100%"},
                        "value-format": "YYYY-MM-DD",
                        "disabled-date": _ctx.disabledDate
                      }, null, 8, ["modelValue", "disabled-date"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_el_form_item, {
            label: "留存率:",
            prop: "retention"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.checkDataForm.retention,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkDataForm.retention) = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelRetention, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.retention,
                      label: item.retentionText,
                      value: item.retention
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.showRetention]
          ]),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onSubmit
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.upExcel
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"]), [
                [_vShow, _ctx.showUpExcel]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createVNode(_component_el_table, {
        data: _ctx.checkTableData,
        "summary-method": _ctx.getSummaries,
        "show-summary": "",
        style: {"width":"100%"},
        stripe: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "date",
            label: "日期",
            align: "center"
          }),
          (_ctx.tableTag)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                prop: "tag",
                label: "渠道名",
                align: "center"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            prop: "accid",
            label: "计费ID",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "settle_predict",
            label: "预估结算量",
            sortable: "",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "settle",
            label: "结算量",
            sortable: "",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "warn_msg",
            label: "质量预警",
            align: "center"
          }, {
            default: _withCtx((props) => [
              (props.row.warn_msg === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "--"))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.row.warn_msg), 1))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "state",
            label: "结算状态",
            align: "center"
          }, {
            default: _withCtx((props) => [
              _createElementVNode("div", null, _toDisplayString(props.row.state === 0 ? '可结算' : '不结算'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "price",
            label: "结算单价",
            align: "center"
          }, {
            default: _withCtx((props) => [
              _createElementVNode("div", null, _toDisplayString(props.row.price === -1 ? '--' : props.row.price), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "money",
            label: "结算金额",
            align: "center"
          }, {
            default: _withCtx((props) => [
              _createElementVNode("div", null, _toDisplayString(props.row.money === -1 ? '--': props.row.money), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "summary-method"])
    ]),
    _: 1
  }))
}